import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { blogData } from '../../data/blogData';  // ← Importa los datos
import '../stylescss/blog.css';

const BlogPostPage = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Buscar el post por slug
    const found = blogData.find(p => p.slug === slug);
    setPost(found || null);
    setLoading(false);
  }, [slug]);

  if (loading) {
    return <div className="blog-loading">Cargando post...</div>;
  }

  if (!post) {
    return <div className="blog-not-found">Post no encontrado.</div>;
  }

  return (
    <div className="blog-container">
      <div className="blog-post-wrapper">
        {post.image && (
          <img src={post.image} alt={post.title} className="blog-post-hero" />
        )}
        <h1 className="blog-title">{post.title}</h1>
        <div className="blog-post-meta">
          <span>📅 {new Date(post.pubDate).toLocaleDateString('es-PE')}</span>
        </div>
        <article className="blog-post-article">
          <div dangerouslySetInnerHTML={{ __html: post.content }} />
        </article>
        <Link to="/blog" className="blog-post-back">← Volver al blog</Link>
      </div>
    </div>
  );
};

export default BlogPostPage;